import type { Page } from "../../../../common/types/base/BaseEntity";
import type { ProjectStatisticsChildVo } from "../../../../common/types/project";
import type { ServiceCostBill, ServiceCostBillQueryParams } from "../../../../common/types/serviceCostBill";
import httpRequest from "./index";
import { BaseService } from "@/api/baseService";

class ServiceCostBillService extends BaseService<ServiceCostBill, any, ServiceCostBillQueryParams, any> {
    public async getListByProjectId(params: ServiceCostBillQueryParams): Promise<Page<ServiceCostBill>> {
        const { data } = await this.service.get(`${this.path}/paging/find-list`, { params });
        return data;
    }

    /**查询服务费账单统计 */
    public async getStaticsByProjectId(params: {
        projectId: number;
        startTime?: string;
        endTime?: string;
    }): Promise<ProjectStatisticsChildVo> {
        const { data } = await this.service.get(`${this.path}/statics`, { params });
        return data;
    }
}

export const serviceCostBillService = new ServiceCostBillService("/service-cost-bill", httpRequest);
